<template>
    <div class="not-found-page">
        <div>
            <h1 class="not-found-page__title">401</h1>
            <h1 class="not-found-page__title">{{ $t('authorisation required') | upperCase }}</h1>
            <div class="notice">
                {{ $t('this page is not publicly avaliable') | capitalize }}.<br>
                {{ $t('to access it please login first') | capitalize }}.
            </div>
        </div>
        <Illustration image="/static/img/illustrations/page__unathorized.svg"/>
    </div>
</template>


<script>
    import { mapGetters, mapActions } from 'vuex';
    import { routeNames } from '@app/router';
    import Modals from '@store/modules/ui/shared/modal/modals';

    export default {
        name: 'PageNotAuthorized',
        created() {
            if (this.isLoggedIn) {
                this.$router.push({ name: routeNames.landing });
            } else if (this.previousRoute) {
                this.setModal(Modals.login.code);
            }
        },
        watch: {
            isLoggedIn(value) {
                if (value) {
                    // spreading beacuse push mutates the object
                    const route = { ...this.previousRoute } || { name: routeNames.landing };
                    this.$router.push(route);
                }
            }
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user'
            ]),
            ...mapGetters('navigation', [
                'previousRoute'
            ]),
            isLoggedIn() {
                return !!this.user;
            }
        },
        methods: {
            ...mapActions('navigation', ['clearPreviousRoute']),
            ...mapActions('ui/modal', ['setModal'])
        },
        beforeDestroy() {
            this.clearPreviousRoute();
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/PageNotAuthorized.vue